module.exports = __webpack_public_path__ + "static/img/tuque.2b2709f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/other/thumbnail/tuque.png
// module id = gPtA
// module chunks = 0